import {FormControl, FormGroup} from '@angular/forms';
import {ConfigurationAccessLevel} from '@app/model/configuration.model';

export interface ConfigurationRequestForm {
	name: FormControl<string>;
	description: FormControl<string>;
	access: FormControl<ConfigurationAccessLevel>;
}

export function buildConfigurationRequestForm(): FormGroup<ConfigurationRequestForm> {
	return new FormGroup<ConfigurationRequestForm>(<ConfigurationRequestForm>{
		description: new FormControl<string>(''),
		name: new FormControl<string>(''),
		access: new FormControl<ConfigurationAccessLevel>('CREATOR_USER', {nonNullable: true})
	});
}
